/*
  DashboardBookingView 0 = vista de booking
  DashboardBookingView 1 = vista de dashboard
*/
const DefaultState = () => {
    return {
      DashboardBookingView: false
    };
  },
  state = DefaultState(),
  getters = {
    DashboardBookingView: state => state.DashboardBookingView
  },
  mutations = {
    DasboardBookingViewset(state, payload) {
      state.DashboardBookingView = payload;
    },
  },
  actions = {
    setDashboardBookingView({
      commit,
      state
    }, payload){
      commit('DasboardBookingViewset', payload);
    }
  };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js